import { jsx as _jsx } from "react/jsx-runtime";
import { AuthProviderCard } from '../components';
export function EmailPasswordSection({ enabled, onToggle }) {
    return /*#__PURE__*/ _jsx(AuthProviderCard, {
        title: "Email/Password Authentication",
        description: "Traditional username and password login",
        enabled: enabled,
        onToggle: onToggle
    });
}
